<template>
  <div>
    <v-dialog v-model="isOpen" persistent max-width="1550">
      <v-card class="align-center text-center">
        <v-card-text>
          <div class="pt-5 mb-3 d-flex align-center justify-space-between">
            <div>
              <h1>Detalhes da importação</h1>
            </div>
            <v-btn icon @click="close()" class="align-self-end">
              <v-icon> mdi-close </v-icon>
            </v-btn>
          </div>
          <v-data-table
            class="my-5"
            :headers="headers"
            :items="cteXmlDetails"
            :items-per-page="cteXmlDetails.length"
            :height="tableHeight"
            :loading="isLoading"
            hide-default-footer
          >
            <template v-slot:[`item.statusName`]="{ item }">
              <span v-if="item.observation" class="red--text">
                <v-icon color="red"> mdi-close </v-icon>
                {{ item.statusName }}
              </span>
              <span v-else>
                {{ item.statusName }}
              </span>
            </template>
            <template v-slot:[`item.fileName`]="{ item }">
              <TruncateDataWithTooltip :data="item.fileName" :lengthDataToTruncate="20"></TruncateDataWithTooltip>
            </template>
            <template v-slot:[`item.accessKeyCte`]="{ item }">
              <copy-to-clipboard-tooltip should-copy :text="item.accessKeyCte"></copy-to-clipboard-tooltip>
            </template>
          </v-data-table>
        </v-card-text>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import { mapActions } from 'vuex';
import Base64Mixin from '@/mixins/base64.mixin';
import TruncateDataWithTooltip from '@/components/Table/TruncateDataWithTooltip.vue';
import CopyToClipboardTooltip from '@/components/CopyToClipboardTooltip.vue';

export default {
  name: 'UploadXmlCte',
  props: {
    isOpen: {
      default: false,
      type: Boolean
    },
    cteXmlId: null
  },
  mixins: [Base64Mixin],
  components: {
    TruncateDataWithTooltip,
    CopyToClipboardTooltip
  },
  data() {
    return {
      isLoading: true,
      cteXmlDetails: [],
      isOpenValidation: false,
      headers: [
        {
          value: 'fileName',
          text: 'NOME DO ARQUIVO',
          sortable: true
        },
        {
          value: 'accessKeyCte',
          text: 'CHAVE CTE',
          sortable: true
        },
        {
          value: 'numberCte',
          text: 'NÚMERO',
          sortable: true
        },
        {
          value: 'statusName',
          text: 'STATUS',
          width: 220,
          sortable: true
        },
        {
          value: 'observation',
          text: 'ERROS',
          sortable: false
        }
      ]
    };
  },

  computed: {
    tableHeight() {
      const hasMoreThanTen = this.cteXmlDetails.length > 10;
      return hasMoreThanTen ? '450' : '';
    }
  },

  watch: {
    isOpen: {
      async handler(isOpen) {
        if (isOpen) {
          this.isLoading = true;

          const detailsCteXml = await this.getDetailsCteXml(this.cteXmlId);

          const cteXmlDetails = detailsCteXml.data.map((item) => {
            return {
              ...item,
              accessKeyCte: this.getAccessKeyCte(item),
              numberCte: item.numberCte ? this.formatNumberCte(item.numberCte) : this.getNumberCte(item.fileName)
            };
          });

          this.cteXmlDetails = cteXmlDetails;

          this.isLoading = false;
        }
      }
    }
  },

  methods: {
    ...mapActions('ImportXmlStore', ['getDetailsCteXml']),

    getAccessKeyCte(item) {
      let accessKeyCte;
      if (!item.accessKeyCte) {
        accessKeyCte = item.fileName.split('_')[0];
        return String(accessKeyCte);
      }

      return String(item.accessKeyCte);
    },

    getNumberCte(fileName) {
      const accessKeyCte = fileName.split('_')[0];
      const numberCte = accessKeyCte.substring(25, 34);
      return numberCte;
    },

    formatNumberCte(numberCte) {
      return String(numberCte).padStart(9, '0');
    },

    close() {
      this.$emit('update:isOpen', false);
      this.cteXmlDetails = [];
    }
  }
};
</script>

<style lang="scss" scoped></style>
